
/*========================================================================
 * $Id: usersourceinfo.js 97320 2017-04-07 11:14:01Z michael.biebl $
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

Mindbreeze.define('api/v2/usersourceinfo',["api/v2/sourceinfo", "service/factory", "underscore"],
function(SourceInfo, ServiceFactory, _) {
  var UserSourceInfo = {};

  var UserSourceInfoServiceStub = UserSourceInfo.UserSourceInfoServiceStub = SourceInfo.SourceInfoServiceStub.extend({
    path: "usersourceinfo"
  });
  
  var UserSourceInfoOutputModel = UserSourceInfo.UserSourceInfoOutputModel = SourceInfo.SourceInfoOutputModel.extend({
  });
  
  var UserSourceInfoServiceFactory = UserSourceInfo.ServiceFactory = function() {}
  
  _.extend(UserSourceInfoServiceFactory.prototype, ServiceFactory.prototype, {
      /*    createInput:  function(attrs,options) { return new SourceInfoInputModel(attrs, options); },*/
    createModel:  function(channel, options) {
      options = options || {};
      options.channel = options.channel || channel;
      options.serviceStub = options.serviceStub || new UserSourceInfoServiceStub();
      var model = new UserSourceInfoOutputModel({}, options);
      return model;
    }
  });

  return UserSourceInfo;
})
;